function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { DomModule } from '@polymer/polymer/lib/elements/dom-module.js';
import { ThemePropertyMixin } from './vaadin-theme-property-mixin.js';
/**
 * @polymerMixin
 * @mixes ThemePropertyMixin
 */

export var ThemableMixin = function ThemableMixin(superClass) {
  return /*#__PURE__*/function (_ThemePropertyMixin) {
    _inherits(VaadinThemableMixin, _ThemePropertyMixin);

    var _super = _createSuper(VaadinThemableMixin);

    function VaadinThemableMixin() {
      _classCallCheck(this, VaadinThemableMixin);

      return _super.apply(this, arguments);
    }

    _createClass(VaadinThemableMixin, null, [{
      key: "finalize",

      /** @protected */
      value: function finalize() {
        var _this = this;

        _get(_getPrototypeOf(VaadinThemableMixin), "finalize", this).call(this);

        var template = this.prototype._template;
        var hasOwnTemplate = this.template && this.template.parentElement && this.template.parentElement.id === this.is;

        var inheritedTemplate = Object.getPrototypeOf(this.prototype)._template;

        if (inheritedTemplate && !hasOwnTemplate) {
          // The element doesn't define its own template -> include the theme modules from the inherited template
          Array.from(inheritedTemplate.content.querySelectorAll('style[include]')).forEach(function (s) {
            _this._includeStyle(s.getAttribute('include'), template);
          });
        }

        this._includeMatchingThemes(template);
      }
      /** @private */

    }, {
      key: "_includeMatchingThemes",
      value: function _includeMatchingThemes(template) {
        var _this2 = this;

        var domModule = DomModule;
        var modules = domModule.prototype.modules;
        var hasThemes = false;
        var defaultModuleName = this.is + '-default-theme';
        Object.keys(modules).sort(function (moduleNameA, moduleNameB) {
          var vaadinA = moduleNameA.indexOf('vaadin-') === 0;
          var vaadinB = moduleNameB.indexOf('vaadin-') === 0;
          var vaadinThemePrefixes = ['lumo-', 'material-'];
          var vaadinThemeA = vaadinThemePrefixes.filter(function (prefix) {
            return moduleNameA.indexOf(prefix) === 0;
          }).length > 0;
          var vaadinThemeB = vaadinThemePrefixes.filter(function (prefix) {
            return moduleNameB.indexOf(prefix) === 0;
          }).length > 0;

          if (vaadinA !== vaadinB) {
            // Include vaadin core styles first
            return vaadinA ? -1 : 1;
          } else if (vaadinThemeA !== vaadinThemeB) {
            // Include vaadin theme styles after that
            return vaadinThemeA ? -1 : 1;
          } else {
            // Lastly include custom styles so they override all vaadin styles
            return 0;
          }
        }).forEach(function (moduleName) {
          if (moduleName !== defaultModuleName) {
            var themeFor = modules[moduleName].getAttribute('theme-for');

            if (themeFor) {
              themeFor.split(' ').forEach(function (themeForToken) {
                if (new RegExp('^' + themeForToken.split('*').join('.*') + '$').test(_this2.is)) {
                  hasThemes = true;

                  _this2._includeStyle(moduleName, template);
                }
              });
            }
          }
        });

        if (!hasThemes && modules[defaultModuleName]) {
          // No theme modules found, include the default module if it exists
          this._includeStyle(defaultModuleName, template);
        }
      }
      /** @private */

    }, {
      key: "_includeStyle",
      value: function _includeStyle(moduleName, template) {
        if (template && !template.content.querySelector("style[include=\"".concat(moduleName, "\"]"))) {
          var styleEl = document.createElement('style');
          styleEl.setAttribute('include', moduleName);
          template.content.appendChild(styleEl);
        }
      }
    }]);

    return VaadinThemableMixin;
  }(ThemePropertyMixin(superClass));
};